import { Typography } from "@material-ui/core";
import React, { useEffect } from "react";

const PayPal = ({
  match: {
    params: { email, total },
  },
}) => {
  useEffect(() => {
    document.getElementById("paypal-form").submit();
  }, []);

  return (
    <>
      <Typography
        component="div"
        style={{ textAlign: "center", paddingTop: 50 }}
      >
        Redirecting to PayPal...
      </Typography>
      <form
        action="https://www.paypal.com/cgi-bin/webscr"
        method="post"
        id="paypal-form"
        style={{ display: "none" }}
      >
        <input type="hidden" name="cmd" value="_xclick" />
        <input
          type="hidden"
          name="business"
          value={decodeURIComponent(email)}
        />
        <input type="hidden" name="lc" value="US" />
        <input type="hidden" name="no_shipping" value="1" />
        <input type="hidden" name="no_note" value="1" />
        <input
          type="hidden"
          name="item_name"
          value="Gem Mint Card Submission"
        />
        <input type="hidden" name="amount" value={decodeURIComponent(total)} />
        <input type="hidden" name="currency_code" value="USD" />
        <input type="hidden" name="button_subtype" value="services" />
        <input
          type="hidden"
          name="bn"
          value="PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest"
        />
        <input
          type="image"
          src="https://www.paypalobjects.com/en_US/i/btn/btn_buynow_SM.gif"
          border="0"
          name="submit"
          alt="PayPal - The safer, easier way to pay online!"
        />
        <img
          alt=""
          border="0"
          src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
          width="1"
          height="1"
        />
      </form>
    </>
  );
};

export default PayPal;
